module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon11.png?43d905aa";